<template>
  <div>
    <t-card v-loading="loading">
      <!-- 検査室入荷詳細画面 -->
      <div :style="{ height: basicHeight + 'px' }">
        <t-form
          label-position="right"
          :label-width="$t('widgetSize.ORDER.SEARCH_LABEL_WIDTH')"
        >
          <t-row
            type="flex"
            justify="start
          "
          >
            <t-col :span="colArr.colL">&nbsp;</t-col>

            <!-- 入荷No -->
            <t-col :span="colArr.colCom">
              <t-form-item
                :label="$t('resource.checkReceInfo.crdReceGoodNo')"
                class="marginBottom"
              >
                <t-input
                  v-if="showReceNoFlg"
                  v-model="receInfoEditForm.crbReceNo"
                  class="commonDialog"
                  :disabled="disabled"
                >
                </t-input>
                <t-input v-else class="commonDialog" :disabled="disabled">
                </t-input>
              </t-form-item>
            </t-col>
            <!-- 仕入先 -->
            <t-col :span="colArr.colCom">
              <t-form-item
                :label="$t('resource.checkReceInfo.crbSupInfo')"
                class="marginBottom"
              >
                <t-select
                  placeholder=""
                  class="commonDialog"
                  :disabled="supFlg"
                  @change="changeSelectData"
                  v-model="receInfoEditForm.crbSupCode"
                >
                  <!-- :placeholder="$t('resource.sys.hidden')" -->
                  <t-option
                    v-for="item in supplierList"
                    :key="item.supCode"
                    :label="item.supCode + ':' + item.supAbbreviation"
                    :value="item.supCode"
                  >
                  </t-option>
                </t-select>
              </t-form-item>
            </t-col>
            <!-- 連絡担当者 -->
            <t-col :span="colArr.colCom">
              <t-form-item
                :label="$t('resource.checkReceInfo.crbUserName')"
                class="marginBottom"
              >
                <!-- UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓ -->
                <!-- 日本権限の変更：権限(読み取り)が必要、権限(入力・修正)が不要 -->
                <!-- <t-select
                  placeholder=""
                  class="commonDialog"
                  v-model="receInfoEditForm.crbUserCode"
                > -->
                <t-select
                  placeholder=""
                  class="commonDialog"
                  v-model="receInfoEditForm.crbUserCode"
                  :disabled="!isDLUserLocal"
                >
                  <!-- UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑ -->
                  <!-- :placeholder="$t('resource.sys.hidden')" -->
                  <t-option
                    v-for="item in userList"
                    :key="item.UserId"
                    :label="item.UserName"
                    :value="item.UserId"
                  >
                  </t-option>
                </t-select>
              </t-form-item>
            </t-col>

            <!-- 入荷日 -->
            <t-col :span="colArr.colCom">
              <t-form-item
                :label="$t('resource.checkReceInfo.crbReceDate')"
                class="marginBottom"
              >
                <!-- UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓ -->
                <!-- 日本権限の変更：権限(読み取り)が必要、権限(入力・修正)が不要 -->
                <!-- <t-date-picker
                  v-model="receInfoEditForm.crbReceDate"
                  class="dialogDate"
                  :clearable="false"
                  type="date"
                  value-format="yyyy/MM/dd"
                  format="yyyy/MM/dd"
                  :editable="false"
                > -->
                <t-date-picker
                  v-model="receInfoEditForm.crbReceDate"
                  class="dialogDate"
                  :clearable="false"
                  type="date"
                  value-format="yyyy/MM/dd"
                  format="yyyy/MM/dd"
                  :editable="false"
                  :disabled="!isDLUserLocal"
                >
                  <!-- UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑ -->
                </t-date-picker>
              </t-form-item>
            </t-col>

            <t-col :span="colArr.colR">&nbsp;</t-col>
          </t-row>

          <t-row type="flex" justify="start">
            <t-col :span="colArr.colL">&nbsp;</t-col>

            <!-- 状態 -->
            <t-col :span="colArr.colCom">
              <t-form-item
                :label="$t('resource.checkReceInfo.crbStatus')"
                class="marginBottom"
              >
                <!-- UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓ -->
                <!-- 日本権限の変更：権限(読み取り)が必要、権限(入力・修正)が不要 -->
                <!-- <t-select
                  v-model="receInfoEditForm.crbStatus"
                  placeholder=""
                  class="commonDialog"
                > -->
                <t-select
                  v-model="receInfoEditForm.crbStatus"
                  placeholder=""
                  class="commonDialog"
                  :disabled="!isDLUserLocal"
                >
                  <!-- UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑ -->
                  <t-option
                    v-for="item in recStatusList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </t-option>
                </t-select>
              </t-form-item>
            </t-col>

            <!-- 運送状態 -->
            <!-- DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓ -->
            <!-- 運送状態の削除 -->
            <!-- <t-col :span="colArr.colCom" v-if="trStatusShowFlg">
              <t-form-item
                :label="$t('resource.checkReceInfo.crbTransStatus')"
                class="marginBottom"
              >
                <t-input
                  v-model="receInfoEditForm.crbTransStatusName"
                  class="commonDialog"
                  maxLength="4"
                  :disabled="disabled"
                ></t-input>
              </t-form-item>
            </t-col> -->
            <!-- DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑ -->
          </t-row>
          <t-row type="flex" justify="start">
            <t-col :span="4" class="col_common_left">
              <!-- 注文一覧選択 -->
              <!-- UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓ -->
              <!-- 日本権限の変更：権限(読み取り)が必要、権限(入力・修正)が不要 -->
              <!-- <t-button
                round
                type="primary"
                class="dialogButton_150_40"
                ref="orderSelectBtn"
                @click="showReceOrderSelectDialog"
              > -->
              <t-button
                round
                type="primary"
                class="dialogButton_150_40"
                ref="orderSelectBtn"
                @click="showReceOrderSelectDialog"
                :disabled="!isDLUserLocal || payExistFlg"
              >
                <!-- UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑ -->

                <i class="el-icon-s-order"></i>
                {{ $t("resource.checkReceInfo.crdOrderInfoButton") }}
              </t-button></t-col
            >

            <t-col :span="4" class="col_common_left">
              <!-- 注文一覧選択 -->
              <!-- UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓ -->
              <!-- 日本権限の変更：権限(読み取り)が必要、権限(入力・修正)が不要 -->
              <!-- <t-button
                round
                type="primary"
                class="dialogButton_150_40"
                ref="importExcel"
                :disabled="!isAddFlg"
                @click="importExcel"
              > -->

              <t-button
                round
                type="primary"
                class="dialogButton_150_40"
                ref="importExcel"
                :disabled="!isAddFlg || !isDLUserLocal"
                @click="importExcel"
              >
                <!-- UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑ -->
                <i class="el-icon-s-order"></i>
                配送単導入
              </t-button>
            </t-col>

            <!-- ファイルインポート -->
            <!-- <input :span="5" type="file" @change="handleFileImport" /> -->

            <t-col :span="5">&nbsp;</t-col>

            <t-col :span="4" class="col_common_right">
              <!-- 入荷チェックリスト出力 -->
              <t-button
                v-if="false"
                round
                type="primary"
                ref="outCheckListBtn"
                class="dialogButton_210_40"
                @click="outCheckListBtnClick()"
                :disabled="isAddFlg"
              >
                <i class="el-icon-download"></i>
                {{ $t("resource.checkReceInfo.RececheckListOutButton") }}
              </t-button>
            </t-col>
          </t-row>
        </t-form>
      </div>

      <div>
        <t-row class="marginBottom">
          <t-col :span="24">
            <!-- テーブル -->
            <div>
              <t-table
                ref="creDetailInfoTable"
                :data="creDetailInfoTable"
                class="table_common"
                header-cell-class-name="bg-default"
                highlight-current-row
                :height="detailHeight"
                :row-class-name="rowClassName"
                :cell-class-name="tableCellClassName"
                border
                fit
              >
                <!-- テーブルの列 -->
                <t-table-column
                  v-for="(column, index) in columns"
                  :key="index"
                  :type="column.type"
                  :prop="column.prop"
                  :label="column.label"
                  :width="column.realWidth"
                  :min-width="column.width"
                  :align="column.align"
                  :header-align="column.headerAlign"
                  :class-name="column.class"
                  :show-overflow-tooltip="column.overflowTooltip"
                >
                  <template slot-scope="scope">
                    <!--UPD 2024/12/16 ZLL 課题_受注製品変更の検討 start↓ -->
                    <!-- <t-input-number
                      v-if="editCellData(scope.row.index, column)"
                      class="cell_input_number"
                      :controls="false"
                      :precision="0"
                      :min="0"
                      :max="999999"
                      :class="{ 'red-text': scope.row.crdProdExKbnName != '-' }"
                      width="100%"
                      v-model="scope.row[column.prop]"
                      @change="
                        changeCellData(scope.row.index, scope.column.index)
                      "
                      :ref="`input${scope.row.index}${column.prop}`"
                      @keyup.native.enter="
                        focusNextInput(scope.row.index, column.prop)
                      "
                      :disabled="scope.row['crdTransStatus'] != '0'"
                    />

                    <t-input
                      v-else-if="
                        column.prop === 'crdRemarks' &&
                        scope.row['crdTransStatus'] === '0'
                      "
                      :class="{ 'red-text': scope.row.crdProdExKbnName != '-' }"
                      v-model="scope.row[column.prop]"
                      maxLength="200"
                      :ref="`input${scope.row.index}${column.prop}`"
                      @keyup.native.enter="
                        focusNextInput(scope.row.index, column.prop)
                      "
                      :disabled="scope.row['crdTransStatus'] != '0'"
                    /> -->

                    <!-- UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓ -->
                    <!-- 運送状態の削除 -->
                    <!-- <t-input-number
                      v-if="editCellData(scope.row.index, column)"
                      class="cell_input_number"
                      :controls="false"
                      :precision="0"
                      :min="0"
                      :max="99999"
                      :class="{ 'red-text': scope.row.crdProdExKbnName != '-' }"
                      width="100%"
                      v-model="scope.row[column.prop]"
                      @blur="
                        changeCellData(scope.row.index, scope.column.index)
                      "
                      :ref="`input${scope.row.index}${column.prop}`"
                      @keyup.native.enter="
                        focusNextInput(scope.row.index, column.prop)
                      "
                      :disabled="scope.row['crdTransStatus'] != '0'"
                      @focus="selectValue($event)"
                    />

                    <t-input
                      v-else-if="
                        column.prop === 'crdRemarks' &&
                        scope.row['crdTransStatus'] === '0'
                      "
                      :class="{ 'red-text': scope.row.crdProdExKbnName != '-' }"
                      v-model="scope.row[column.prop]"
                      maxLength="200"
                      :ref="`input${scope.row.index}${column.prop}`"
                      @keyup.native.enter="
                        focusNextInput(scope.row.index, column.prop)
                      "
                      :disabled="scope.row['crdTransStatus'] != '0'"
                      @focus="selectValue($event)"
                    /> -->
                    <!--UPD 2024/12/16 ZLL 課题_受注製品変更の検討 end↑ -->

                    <!-- 外観检查  -->
                    <!-- <t-checkbox
                      v-else-if="column.prop === 'crdAppearanceCheck'"
                      v-model="scope.row['crdAppearanceCheckbool']"
                      @change="
                        handleCheckboxChange(
                          scope.row.index,
                          scope.column.index
                        )
                      "
                      :disabled="scope.row['crdTransStatus'] != '0'"
                    ></t-checkbox> -->

                    <!-- UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓ -->
                    <!-- 日本権限の変更：権限(読み取り)が必要、権限(入力・修正)が不要 -->
                    <!-- <t-input-number
                      v-if="editCellData(scope.row.index, column)"
                      class="cell_input_number"
                      :controls="false"
                      :precision="0"
                      :min="0"
                      :max="99999"
                      :class="{ 'red-text': scope.row.crdProdExKbnName != '-' }"
                      width="100%"
                      v-model="scope.row[column.prop]"
                      @blur="
                        changeCellData(scope.row.index, scope.column.index)
                      "
                      :ref="`input${scope.row.index}${column.prop}`"
                      @keyup.native.enter="
                        focusNextInput(scope.row.index, column.prop)
                      "
                      @focus="selectValue($event)"
                    /> -->
                    <t-input-number
                      v-if="editCellData(scope.row, column) && isDLUserLocal"
                      class="cell_input_number"
                      :controls="false"
                      :precision="0"
                      :min="0"
                      :max="99999"
                      :class="{ 'red-text': scope.row.crdProdExKbnName != '-' }"
                      width="100%"
                      v-model="scope.row[column.prop]"
                      @blur="
                        changeCellData(scope.row.index, scope.column.index)
                      "
                      :ref="`input${scope.row.index}${column.prop}`"
                      @keyup.native.enter="
                        focusNextInput(scope.row.index, column.prop)
                      "
                      @focus="selectValue($event)"
                    />
                    <!-- UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑ -->

                    <!-- DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓ -->
                    <!-- 課題_備考機能の追加 -->
                    <!-- <t-input
                      v-else-if="column.prop === 'crdRemarks'"
                      :class="{ 'red-text': scope.row.crdProdExKbnName != '-' }"
                      v-model="scope.row[column.prop]"
                      maxLength="200"
                      :ref="`input${scope.row.index}${column.prop}`"
                      @keyup.native.enter="
                        focusNextInput(scope.row.index, column.prop)
                      "
                      @focus="selectValue($event)"
                    /> -->
                    <!-- DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑ -->

                    <!-- 外観检查  -->
                    <t-checkbox
                      v-else-if="column.prop === 'crdAppearanceCheck'"
                      v-model="scope.row['crdAppearanceCheckbool']"
                    ></t-checkbox>
                    <!-- UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑ -->

                    <span v-else>
                      {{ scope.row[column.prop] }}
                    </span>
                  </template>
                </t-table-column>

                <!-- ADD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓ -->
                <!-- 課題_備考機能の追加 -->
                <!-- UPD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 start↓ -->
                <!-- 共通備考の調整 -->
                <!-- <t-table-column
                  :label="$t('resource.REMARKS_ADD.REMARKS')"
                  class="cell_txt_center"
                  :min-width="100"
                >
                  <template slot-scope="scope">
                    <div class="button-container">
                      <t-tooltip placement="bottom" effect="light">
                        <div
                          slot="content"
                          class="tooltip-content"
                          v-html="
                            formatRemarksShowProc(scope.row.aodProdRemarksSum)
                          "
                        ></div>
                        <t-button
                          :type="getIconTypeProc(scope.row.aodProdRemarksSum)"
                          icon="el-icon-search"
                          size="small"
                          circle
                        >
                        </t-button>
                      </t-tooltip>
                      <t-button
                        type="warning"
                        icon="el-icon-edit"
                        size="small"
                        circle
                        @click="addRemarksProd(scope.row, $event)"
                      ></t-button>
                    </div>
                  </template>
                </t-table-column> -->
                <t-table-column
                  :label="$t('resource.REMARKS_ADD.REMARKS')"
                  prop="aodProdRemarksSum"
                  :class-name="'cell_txt_center'"
                  :width="getRemarksColumnWidthProc()"
                >
                  <template slot-scope="scope">
                    <div class="bikouDiv">
                      <!-- 備考表示 -->
                      <span class="bikouText">
                        {{ scope.row.aodProdRemarksSum }}
                      </span>
                      <!-- 備考編集 -->
                      <!-- UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓ -->
                      <!-- 日本権限の変更：権限(読み取り)が必要、権限(入力・修正)が不要 -->
                      <!-- <t-button
                        type="warning"
                        icon="el-icon-edit"
                        size="small"
                        class="bikouButton"
                        circle
                        @click="showRemarksDialogProc(scope.row, $event)"
                      ></t-button> -->
                      <t-button
                        type="warning"
                        icon="el-icon-edit"
                        size="small"
                        class="bikouButton"
                        :disabled="!isDLUserLocal"
                        circle
                        @click="showRemarksDialogProc(scope.row, $event)"
                      ></t-button>
                      <!-- UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑ -->
                    </div>
                  </template>
                </t-table-column>
                <!-- UPD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 end↑ -->
                <!-- ADD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑ -->
              </t-table>
            </div>
          </t-col>
        </t-row>
      </div>
      <div :style="{ height: bottomHeight + 'px' }">
        <t-form label-position="right" label-width="100px">
          <t-row type="flex" justify="end">
            <div>
              <t-col :span="24">
                <!-- UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓ -->
                <!-- 日本権限の変更：権限(読み取り)が必要、権限(入力・修正)が不要 -->
                <!-- <t-button
                  round
                  type="warning"
                  class="dialogButton_confirm_120_40"
                  ref="confirmBtn"
                  @click="checkConfirm"
                  :disabled="btnClickFlg"
                > -->
                <t-button
                  round
                  type="warning"
                  class="dialogButton_confirm_120_40"
                  ref="confirmBtn"
                  @click="checkConfirm"
                  :disabled="btnClickFlg || !isDLUserLocal"
                >
                  <!-- UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑ -->

                  <i class="el-icon-check"></i>
                  {{ $t("resource.sys.sure") }}</t-button
                >
              </t-col>
            </div>
          </t-row>
        </t-form>
      </div>
    </t-card>
  </div>
</template>
<script>
import {
  ShowImportResultDialog,
  ShowReceOrderSelectDialog,
} from "@/components/Dialog";
import { t } from "@/locales";
import {
  changReceInfo,
  creatReceInfo,
  getReceDetialInfoByReceNo,
  getReceDetialSelectInfo,
  outCheckList,
  searchCheckReceByDeliceryFile,
} from "@/services/checkReceInfo";
import { showRemarksDialog, showRemarksUpdDialog } from "@/services/common";
import {
  cmpBasicData,
  cmpDetailData,
  formatDateToString,
  formatRemarksShow,
  formatStringToCurrency,
  getAbleSupplierInfoList,
  getAbleUserInfoList,
  getDialogContentHeight,
  getEditColWidthArr,
  getIconType,
  getRemarksColumnWidth,
  readZColumnFromXLSX,
  ShowMergeExKbn,
} from "@/utils/comFunction";
import {
  DIALOG_LINE_HEIGHT,
  FINAL_STR,
  STR_EMPTY,
  STR_FIVE,
  STR_ONE,
} from "@/utils/const";
import { flexColumnWidth, setColumnWidth } from "@/utils/table";
import { Message, Modal } from "@tellus/component";

export default {
  data() {
    return {
      receInfoEditForm: {
        // 入荷No
        crbReceNo: "",
        // 仕入先Code
        crbSupCode: "",
        // 仕入先Code: 仕入先名
        crbSupInfo: "",
        // 担当者Id
        crbUserCode: "",
        // 入荷日
        crbReceDate: "",
        // 検査室入荷状態
        crbStatus: "",
        // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
        // 運送状態の削除
        // 運送状態
        // crbTransStatusName: "",
        // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
      },

      receOrderDialogForm: {},

      // 入荷詳細情報
      creDetailInfoTable: [],

      // 外観检查Flag
      checkBoxFlg: false,

      // 画面状態：true:新規　false:編集
      isAddFlg: false,

      //基本情報のheight
      basicHeight: DIALOG_LINE_HEIGHT * 3,

      //合計情報のheight
      bottomHeight: DIALOG_LINE_HEIGHT * 1,

      //明細情報のheight 20:Tableと合計行の間隔調整用(Table的marginTop + bottom)
      detailHeight: getDialogContentHeight(
        window.innerHeight,
        DIALOG_LINE_HEIGHT * 3,
        DIALOG_LINE_HEIGHT * 1,
        20
      ),

      //列の幅
      colArr: getEditColWidthArr(window.innerWidth, 4),

      // -----------------------

      // 待つ
      loading: true,

      showReceNoFlg: false,

      disabled: true,

      supFlg: false,

      checkFlg: false,

      // 確定ボタンFlag
      btnClickFlg: true,

      // ADD 2025/10/28 ZLL 課題_251024顧客からの改善したい点への対応 start↓
      //支払状態区分
      payExistFlg: false,
      // ADD 2025/10/28 ZLL 課題_251024顧客からの改善したい点への対応 end↑

      // 運送状態表示Flag
      trStatusShowFlg: false,

      // 入荷チェックリスト出力ボタン表示Flag
      CheckListbutShowFlg: true,

      // 仕入先
      supplierList: [],

      // 担当者
      userList: [],

      //　入荷状態
      recStatusList: [],

      maxheight: t("widgetSize.dialog.HEIGHT_TABLE"),

      //テーブルの列
      columns: [
        // ADD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 start↓
        // 課題_納期分割機能の追加
        {
          // 仕入先納期列
          prop: "odDueDate",
          label: t("resource.checkReceInfo.SUPPLIER_DUE_DATE"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_center",
          overflowTooltip: true,
        },
        // ADD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 end↑

        {
          // 品名
          prop: "aodProdName",
          label: t("resource.checkReceInfo.crdProductName"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_left",
          overflowTooltip: true,
        },
        // 図番
        {
          prop: "aodProdDrawNo",
          label: t("resource.checkReceInfo.crdPictureNo"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_left",
          overflowTooltip: true,
        },
        // 注文数
        {
          prop: "odProdQuantity",
          label: t("resource.checkReceInfo.crdCount"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_right",
          overflowTooltip: false,
        },
        // 注文クローズ数
        // {
        //   prop: "odProdCloseQty",
        //   label: t("resource.checkReceInfo.crdCloseCount"),
        //   width: t("widgetSize.tableCommon.defaultWidth"),
        //   class: "cell_txt_right",
        //   overflowTooltip: false,
        // },
        // 単位
        {
          prop: "aodProdUnit",
          label: t("resource.checkReceInfo.crdUnit"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_center",
          overflowTooltip: false,
        },
        // DEL 2025/03/19 ZLL 課題_形状、素材、処理を削除したい start↓
        // // 素材
        // {
        //   prop: "aodProdMaterial",
        //   label: t("resource.checkReceInfo.crdMaterial"),
        //   width: t("widgetSize.tableCommon.defaultWidth"),
        //   class: "cell_txt_left",
        //   overflowTooltip: false,
        // },
        // // 処理
        // {
        //   prop: "aodProdTreatment",
        //   label: t("resource.checkReceInfo.crdTreatment"),
        //   width: t("widgetSize.tableCommon.defaultWidth"),
        //   class: "cell_txt_left",
        //   overflowTooltip: false,
        // },
        // DEL 2025/03/19 ZLL 課題_形状、素材、処理を削除したい end↑
        // // 加工単価
        // {
        //   prop: "odUPrice",
        //   label: t("resource.checkReceInfo.crdProcessUnit"),
        //   width: "120px",
        //   class: "cell_txt_right",
        //   overflowTooltip: false,
        // },

        // 入荷済み数
        {
          prop: "crdReceCompQty",
          label: t("resource.checkReceInfo.crdArrivalCompQty"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_right",
          overflowTooltip: false,
        },

        // ADD 2025/07/01 ZLL 課題_数量·纳期调整機能の追加 start↓
        // 日本入荷NG数の追加
        {
          prop: "jpRcvNgQty",
          label: t("resource.checkReceInfo.JP_RCV_NG_SUM"),
          width: t("widgetSize.tableCommon.width80"),
          class: "cell_txt_right",
          overflowTooltip: false,
        },
        // ADD 2025/07/01 ZLL 課題_数量·纳期调整機能の追加 end↑

        // クローズ済み数
        // {
        //   prop: "crdCloseCompQty",
        //   label: t("resource.checkReceInfo.crdArrivalCloseCompQty"),
        //   width: t("widgetSize.tableCommon.defaultWidth"),
        //   class: "cell_txt_right",
        //   overflowTooltip: false,
        // },

        // 入荷数
        {
          prop: "crdReceQty",
          label: t("resource.checkReceInfo.crdReceQty"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_right",
          overflowTooltip: false,
        },
        // OK数
        {
          prop: "crdSizeCheckOkQty",
          label: t("resource.checkReceInfo.crdSizeCheckOkQty"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_right",
          overflowTooltip: false,
        },
        // NG数
        {
          prop: "crdSizeCheckNgQty",
          label: t("resource.checkReceInfo.crdSizeCheckNgQty"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_right",
          overflowTooltip: false,
        },

        // クローズ数
        // {
        //   prop: "crdCloseQty",
        //   label: t("resource.checkReceInfo.crdCloseQty"),
        //   width: t("widgetSize.tableCommon.defaultWidth"),
        //   class: "cell_txt_right",
        //   overflowTooltip: false,
        // },

        // 入荷残
        {
          prop: "crdRecelRemnant",
          label: t("resource.checkReceInfo.crdRemnant"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_right",
          overflowTooltip: false,
        },

        // クローズ残
        // {
        //   prop: "crdCloseRemnant",
        //   label: t("resource.checkReceInfo.crdCloseRemnant"),
        //   width: t("widgetSize.tableCommon.defaultWidth"),
        //   class: "cell_txt_right",
        //   overflowTooltip: false,
        // },

        // 外観检查
        // {
        //   prop: "crdAppearanceCheck",
        //   label: t("resource.checkReceInfo.crdAppearanceCheck"),
        //   width: t("widgetSize.tableCommon.defaultWidth"),
        //   class: "cell_txt_center",
        //   overflowTooltip: false,
        // },

        // 異常区分
        {
          prop: "crdProdExKbnName",
          label: t("resource.checkReceInfo.exceptionKbn"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_center",
          overflowTooltip: false,
        },

        // 注文No
        {
          prop: "crdOrderNoShow",
          label: t("resource.checkReceInfo.crdOrderNo"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_left",
          overflowTooltip: false,
        },

        // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
        // 課題_備考機能の追加
        // 備考
        // {
        //   prop: "crdRemarks",
        //   label: t("resource.checkReceInfo.crdBikou"),
        //   realWidth: "180",
        //   width: "180",
        //   class: "cell_txt_left",
        //   overflowTooltip: false,
        // },
        // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
      ],

      // 編集可能な列
      columnEditable: [
        "crdReceQty",
        "crdSizeCheckNgQty",
        "crdAppearanceCheck",
        // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
        // 課題_備考機能の追加
        // "crdRemarks",
        // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑

        "crdCloseQty",
      ],

      //追加された「仕入先」列の番号
      newColumnNo: 0,

      fileJsonData: [],

      // 読み込み回数
      numLoads: 1,

      // 比較用基本情報
      cmpBasicResult: {},

      // 比較用明細情報
      cmpDetailResult: {},
      // ADD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 start↓
      // 共通備考の調整（備考更新時刻）
      aodUpdateTime: null,
      // ADD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 end↑

      // ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓
      //権限（false: 日本、true：大連（ 品質保証部））
      isDLUserLocal: false,
      // ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑

      // ADD 2025/12/08 ZLL 課題_251208顧客からの改善したい点への対応 start↓
      oldSupCode: "",
      // ADD 2025/12/08 ZLL 課題_251208顧客からの改善したい点への対応 end↑
    };
  },

  props: {
    isAdd: {
      Type: Boolean,
      default: false,
    },
    RowData: {
      Type: Object,
    },
  },
  mounted() {
    //テーブルの高さを監視する
    window.addEventListener("resize", this.handleResize);

    // ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓
    // 権限の取得
    this.isDLUserLocal = sessionStorage.getItem("isDLUser") === "true";
    // ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑
  },

  created() {
    this.isAddFlg = this.isAdd;

    // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
    // 運送状態の削除
    // 運送状態追加
    // this.generateColumns();
    // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑

    // 列幅に自動調整
    setColumnWidth(this.columns, this.creDetailInfoTable);

    // 初期化
    this.init();
  },

  methods: {
    // 初期化
    init() {
      // 開始するのを待ちます
      this.loading = true;

      // ドロップダウン選択データ取得
      this.getReceDetialSelectInfo();
    },

    // 入荷詳細画面情報の取得
    getReceDetialInfoByReceNo(receNo) {
      getReceDetialInfoByReceNo(receNo)
        .then((res) => {
          // 画面情報
          this.receInfoEditForm = res.BasicResult;

          // 入荷詳細画面のテーブルの列
          this.creDetailInfoTable = res.DetailResult;

          // ADD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 start↓
          // 共通備考の調整（備考更新時刻）
          if (res.DetailResult != null && res.DetailResult.length != 0) {
            this.aodUpdateTime = res.DetailResult[0].aodUpdateTime;
          }
          // ADD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 end↑

          // データの読み込
          this.dataProcess();

          // 列幅に自動調整
          setColumnWidth(this.columns, this.creDetailInfoTable);
        })
        .catch((err) => {
          if (err.data != null) {
            Message.showError(
              t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
            );
          } else {
            Message.showError(t("message.COMMON_MESSAGE.SEARCH_FAILURE"));
          }
        })
        .finally(() => {
          // 閉じるのを待ちます
          this.loading = false;
        });
    },

    // ドロップダウン選択データ取得
    getReceDetialSelectInfo() {
      getReceDetialSelectInfo()
        .then((res) => {
          // 仕入先
          this.supplierList = res.SupCodeAndNames;
          // 担当者
          this.userList = res.UserNames;
          // 　入荷状態
          this.recStatusList = res.StatusList;

          this.getAbleList();

          // 初期化
          this.initScream();
        })
        .catch((err) => {
          if (err.data != null) {
            Message.showError(
              t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
            );
          } else {
            Message.showError(
              t("message.COMMON_MESSAGE.DETAIL_SEARCH_FAILURE")
            );
          }

          // 閉じるのを待ちます
          this.loading = false;
        });
    },

    // 初期化
    initScream() {
      if (this.isAddFlg) {
        // 入荷日
        this.receInfoEditForm.crbReceDate = formatDateToString(new Date());

        // 仕入先Code
        this.receInfoEditForm.crbSupCode = this.supplierList[0].supCode;

        // ADD 2025/12/08 ZLL 課題_251208顧客からの改善したい点への対応 start↓
        // 仕入先の履歴
        this.oldSupCode = this.receInfoEditForm.crbSupCode;
        // ADD 2025/12/08 ZLL 課題_251208顧客からの改善したい点への対応 end↑

        // 仕入先Code: 仕入先名
        this.receInfoEditForm.crbSupInfo =
          this.supplierList[0].supCode +
          ":" +
          this.supplierList[0].supAbbreviation;

        // 担当者Id
        this.receInfoEditForm.crbUserCode = localStorage.getItem(
          FINAL_STR.USER_ID
        );

        // 入荷状態
        this.receInfoEditForm.crbStatus = FINAL_STR.RECE_STATUS_NEW;

        // 列幅に自動調整
        setColumnWidth(this.columns, this.creDetailInfoTable);

        // 閉じるのを待ちます
        this.loading = false;
      } else {
        // 入荷NO
        this.showReceNoFlg = true;

        // 仕入先Flg
        this.supFlg = true;

        // 確定ボタンFlag
        this.btnClickFlg = false;

        // 運送状態表示Flag
        this.trStatusShowFlg = true;

        // 入荷詳細画面情報の取得
        this.getReceDetialInfoByReceNo(this.RowData.crbReceNo);
      }
    },

    // 注文製品選択画面
    showReceOrderSelectDialog() {
      // 注文製品選択画面
      ShowReceOrderSelectDialog(
        {
          isAdd: false,
          tableData: this.creDetailInfoTable,
          ReceInfoEditForm: this.receInfoEditForm,
          ReceOrderDialogForm: this.receOrderDialogForm,
          SupplierList: this.supplierList,
        },
        t("resource.checkReceInfo.crdOrderSelectDialog"),
        (target) => {
          if (!!target) {
            this.receOrderDialogForm = target.ReceOrderDialogForm;

            // ADD 2025/12/08 ZLL 課題_251208顧客からの改善したい点への対応 start↓
            if (
              this.receInfoEditForm.crbSupInfo !=
                this.receOrderDialogForm.crbSupInfo ||
              this.receInfoEditForm.crbSupCode !=
                this.receOrderDialogForm.crbSupCode
            ) {
              this.receInfoEditForm.crbSupCode =
                this.receOrderDialogForm.crbSupCode;

              // 仕入先の履歴
              this.oldSupCode = this.receInfoEditForm.crbSupCode;
            }
            // ADD 2025/12/08 ZLL 課題_251208顧客からの改善したい点への対応 end↑

            let creDetailInfoTable = this.creDetailInfoTable;

            target.CurrentCell.forEach((item) => {
              let existingProductIndex = creDetailInfoTable.findIndex(
                (p) =>
                  p.crdOrderNo == item.crdOrderNo &&
                  p.crdDetailNo == item.crdDetailNo &&
                  p.crdProdExKbn == item.crdProdExKbn
              );

              if (existingProductIndex !== -1) {
                // 品名
                creDetailInfoTable[existingProductIndex].aodProdName =
                  item.aodProdName;

                // 図番
                creDetailInfoTable[existingProductIndex].aodProdDrawNo =
                  item.aodProdDrawNo;
                // 数量
                creDetailInfoTable[existingProductIndex].odProdQuantity =
                  item.odProdQuantity;
                // 単位
                creDetailInfoTable[existingProductIndex].aodProdUnit =
                  item.aodProdUnit;

                // DEL 2025/03/19 ZLL 課題_形状、素材、処理を削除したい start↓
                // 素材
                // creDetailInfoTable[existingProductIndex].aodProdMaterial =
                //   item.aodProdMaterial;
                // // 処理
                // creDetailInfoTable[existingProductIndex].aodProdTreatment =
                //   item.aodProdTreatment;
                // DEL 2025/03/19 ZLL 課題_形状、素材、処理を削除したい end↑
                // 加工単価
                creDetailInfoTable[existingProductIndex].odUPrice =
                  item.odUPrice;
                // 加工単価
                creDetailInfoTable[existingProductIndex].crdReceCompQty =
                  item.crdReceCompQty;
              } else {
                // 入荷数
                item.crdReceQty = item.crdRemnant;
                // クローズ数
                item.crdCloseQty = 0;
                // OK数
                item.crdSizeCheckOkQty = item.crdRemnant;
                // NG数
                item.crdSizeCheckNgQty = 0;

                // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
                // 運送状態の削除
                // item.crdRemarks = "";
                // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
                creDetailInfoTable.push(item);
              }
            });

            this.creDetailInfoTable = this.creDetailInfoTable.filter((p) =>
              target.CurrentCell.some(
                (t) =>
                  p.crdOrderNo == t.crdOrderNo &&
                  p.crdDetailNo == t.crdDetailNo &&
                  p.crdProdExKbn == t.crdProdExKbn
              )
            );

            setColumnWidth(this.columns, this.creDetailInfoTable);

            // データの読み込
            this.dataProcess();

            // 確定ボタンFlag
            this.btnClickFlg = false;

            this.showReceNoFlg = true;
          }
        }
      );

      // フォーカス削除
      this.$refs.orderSelectBtn.$el.blur();
    },

    // 使用可能な担当者リスト、得意先リストの取得
    getAbleList() {
      // 担当者リスト
      this.userList = getAbleUserInfoList(
        this.userList,
        this.receInfoEditForm.crbUserCode
      );

      var supCode;
      if (!!this.receInfoEditForm.crbSupCode) {
        supCode = this.receInfoEditForm.crbSupCode;
      }

      // 得意先リスト
      this.supplierList = getAbleSupplierInfoList(this.supplierList, supCode);

      if (!this.receInfoEditForm.crbSupCode) {
        this.receInfoEditForm.crbSupCode = this.supplierList[0]?.supCode;
        // 仕入先の履歴
        this.oldSupCode = this.receInfoEditForm.crbSupCode;
      }
    },

    // データの読み込
    dataProcess() {
      // ADD 2025/10/28 ZLL 課題_251024顧客からの改善したい点への対応 start↓
      //仕入先支払データ存在する区分
      let payExistFlg = this.creDetailInfoTable.some((item) => item.crdPayFlg);

      // 仕入先支払データ存在の場合、ボタンは使用できません
      if (payExistFlg) {
        this.payExistFlg = true;
      } else {
        this.payExistFlg = false;
      }
      // ADD 2025/10/28 ZLL 課題_251024顧客からの改善したい点への対応 end↑

      this.creDetailInfoTable.map((item) => {
        // ADD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 start↓
        // 課題_納期分割機能の追加
        item.crdProdExKbnName = ShowMergeExKbn(
          item.crdProdExKbn,
          item.odProdReceExKbn
        );
        // ADD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 end↑

        // UPD 2025/07/01 ZLL 課題_数量·纳期调整機能の追加 start↓
        // 課題_納期分割機能の追加
        // // 入荷残：（注文数 - 注文クローズ数）-(入荷済み数 - クローズ済み数) - (入荷OK数 - クローズ数)
        // item.crdRecelRemnant =
        //   // 注文数-
        //   (item.odProdQuantity || 0) -
        //   // 注文クローズ数 -
        //   // - item.odProdCloseQty
        //   // 入荷済み数 -
        //   (item.crdReceCompQty || 0) -
        //   // クローズ済み数 -
        //   //  - item.crdCloseCompQty
        //   // 入荷OK数 -
        //   (item.crdSizeCheckOkQty || 0);
        // // クローズ数
        // // - item.crdCloseQty

        // 入荷残：（注文数）-(入荷済み数) - (入荷OK数) + 日本入荷NG数
        item.crdRecelRemnant =
          // 注文数-
          (item.odProdQuantity || 0) -
          // 入荷済み数 -
          (item.crdReceCompQty || 0) -
          // 入荷OK数 -
          (item.crdSizeCheckOkQty || 0) +
          // 日本入荷NG数
          (item.jpRcvNgQty || 0);
        // UPD 2025/07/01 ZLL 課題_数量·纳期调整機能の追加 end↑

        // クローズ残：注文クローズ数 - クローズ済み数 - 本データのクローズ数
        item.crdCloseRemnant =
          // 注文クローズ数 -
          item.odProdCloseQty -
          // クローズ済み数 -
          item.crdCloseCompQty -
          // クローズ数
          item.crdCloseQty;

        // 加工単価
        item.odUPrice = formatStringToCurrency(item.odUPrice);

        // 読み込み回数 = 1
        if (!this.isAddFlg && this.numLoads == 1) {
          // 比較用基本情報
          this.cmpBasicResult = JSON.parse(
            JSON.stringify(this.extractBasic(this.receInfoEditForm))
          );

          // 比較用明細情報
          this.cmpDetailResult = JSON.parse(
            JSON.stringify(this.extractDetails(this.creDetailInfoTable))
          );

          // 読み込み回数 + 1
          this.numLoads = this.numLoads + 1;
        }

        return item;
      });
    },

    //テーブルの高さを設定する
    handleResize() {
      this.detailHeight = getDialogContentHeight(
        window.innerHeight,
        DIALOG_LINE_HEIGHT * 3,
        DIALOG_LINE_HEIGHT * 1,
        20
      );

      this.colArr = getEditColWidthArr(window.innerWidth, 4);
    },

    // セルの配置
    tableCellClassName({ row, column, rowIndex, columnIndex }) {
      row.index = rowIndex;
      column.index = columnIndex;

      // ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓
      // 日本権限の変更：権限(読み取り)が必要、権限(入力・修正)が不要
      if (!this.isDLUserLocal) {
        return;
      }
      // ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑

      // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
      // 運送状態を削除
      /* if (FINAL_STR.TRD_TRANS_STATUS_NO_TRANS != row.crdTransStatus) {
        return false;
      } */
      // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑

      // ADD 2025/10/28 ZLL 課題_251024顧客からの改善したい点への対応 start↓
      // 支払した入荷データが入力不可を表示する  true:支払済み、false:未支払
      if (row.crdPayFlg) {
        return;
      }
      // ADD 2025/10/28 ZLL 課題_251024顧客からの改善したい点への対応 end↑

      if (
        this.columnEditable.includes(column.property) ||
        (column.property && column.property.toString().includes("newColumn"))
      ) {
        //編集可能の背景色
        return "bg-cell-editable";
      }
    },

    // 製品異常
    rowClassName({ row, rowIndex }) {
      if (row.crdProdExKbnName != FINAL_STR.PROD_EX_GENERAL_STR) {
        return "textColor";
      }
    },

    // データの変更
    changeCellData(row, column, currentValue, oldValue) {
      // 行データ
      let element = this.creDetailInfoTable[row];

      // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
      // 課題_運送状態を削除
      // 状態が「未運送」ではありません。入荷明細の内容は入力不可に変更されます
      // if (FINAL_STR.TRD_TRANS_STATUS_NO_TRANS != element.crdTransStatus) {
      //   return;
      // }
      // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑

      // 入荷数
      if (!element.crdReceQty) {
        element.crdReceQty = 0;
      }

      // NG数
      if (!element.crdSizeCheckNgQty) {
        element.crdSizeCheckNgQty = 0;
      }

      // クローズ数
      if (!element.crdCloseQty) {
        element.crdCloseQty = 0;
      }

      // 入荷数
      let crdReceQty = Number(element.crdReceQty);

      // 寸法検査OK数 = 入荷数 ‐ 寸法検査NG数
      element.crdSizeCheckOkQty = crdReceQty - element.crdSizeCheckNgQty;

      // UPD 2025/07/01 ZLL 課題_数量·纳期调整機能の追加 start↓
      // 入荷残 = 注文数  - 注文クローズ数  - 入荷済み数  - クローズ済み数 - 寸法検査OK数  - クローズ数
      // 課題_納期分割機能の追加
      // element.crdRecelRemnant =
      //   element.odProdQuantity -
      //   // element.odProdCloseQty -
      //   element.crdReceCompQty -
      //   // element.crdCloseCompQty -
      //   element.crdSizeCheckOkQty;
      // // -
      // //   element.crdCloseQty
      // 入荷残 = 注文数  - 注文クローズ数  - 入荷済み数  - クローズ済み数 - 寸法検査OK数  - クローズ数 + 日本入荷NG数
      element.crdRecelRemnant =
        element.odProdQuantity -
        element.crdReceCompQty -
        element.crdSizeCheckOkQty +
        element.jpRcvNgQty;

      // UPD 2025/07/01 ZLL 課題_数量·纳期调整機能の追加 end↑

      // クローズ残：注文クローズ数 - クローズ済み数 - 本データのクローズ数
      element.crdCloseRemnant =
        element.odProdCloseQty - element.crdCloseCompQty - element.crdCloseQty;

      // this.currentCell = null;
    },

    // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
    // 課題_運送状態を削除
    // チェックボックスの選択
    // handleCheckboxChange(row, column) {
    // 行データ
    // let element = this.creDetailInfoTable[row];

    // 状態が「未運送」ではありません。入荷明細の内容は入力不可に変更されます
    // if (FINAL_STR.TRANS_STATUS_NO_TRANS_STR != element.crdTransStatusName) {
    //   return;
    // }
    // },
    // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑

    // ダイアログを閉じる
    close() {
      this.$emit("cancel");
    },

    editCellData(row, column) {
      // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
      // 課題_運送状態を削除
      // if (
      //   FINAL_STR.TRD_TRANS_STATUS_NO_TRANS !=
      //   this.creDetailInfoTable[row].crdTransStatus
      // ) {
      //   return false;
      // }
      // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑

      // ADD 2025/10/28 ZLL 課題_251024顧客からの改善したい点への対応 start↓
      // 支払した入荷データが入力不可を表示する  true:支払済み、false:未支払
      if (row.crdPayFlg) {
        return false;
      }
      // ADD 2025/10/28 ZLL 課題_251024顧客からの改善したい点への対応 end↑

      // 外観検査
      if (column.prop === FINAL_STR.CRD_APPEARANCE_CHECK) {
        return false;
      }

      // 備考
      if (column.prop === FINAL_STR.CRD_REMARKS) {
        return false;
      }

      if (!this.columnEditable.includes(column.prop)) {
        return false;
      }

      return true;
    },

    checkConfirm() {
      let DetailInfo = [];
      // ADD 2025/12/08 ZLL 課題_251208顧客からの改善したい点への対応 start↓
      if (this.creDetailInfoTable.length > 0) {
        // ADD 2025/12/08 ZLL 課題_251208顧客からの改善したい点への対応 end↑
        this.loading = true;

        for (let index = 0; index < this.creDetailInfoTable.length; index++) {
          const item = this.creDetailInfoTable[index];

          // 入力チェック
          if (!this.inputCheck(item)) {
            this.loading = false;
            return;
          }
          DetailInfo.push({
            crdReceNo: this.receInfoEditForm.crbReceNo,
            crdOrderNo: item.crdOrderNo,
            crdDetailNo: item.crdDetailNo,
            crdReceQty: item.crdReceQty,
            crdSizeCheckOkQty: item.crdSizeCheckOkQty,
            crdSizeCheckNgQty: item.crdSizeCheckNgQty,
            crdAppearanceCheck: item.crdAppearanceCheckbool ? 1 : 0,
            // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
            // 課題_備考機能の追加
            // crdRemarks: item.crdRemarks,
            // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
            // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
            // 課題_運送状態を削除
            // crdTransStatus: item.crdTransStatus,
            // crdTransStatusName: item.crdTransStatusName,
            // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
            crdCloseQty: item.crdCloseQty,
            crdQuoteNo: item.crdQuoteNo,
            crdProdNo: item.crdProdNo,
            crdProdExKbn: item.crdProdExKbn,
            crdReceDetailNo: item.crdReceDetailNo,
            crdCreateTime: item.crdCreateTime,
            crdCreateUser: item.crdCreateUser,
            crdUpdateTime: item.crdUpdateTime,
            crdUpdateUser: item.crdUpdateUser,
            // ADD 2024/12/16 ZLL 課題_受注製品変更の検討 start↓
            crdReceCompQty: item.crdReceCompQty,
            // ADD 2024/12/16 ZLL 課題_受注製品変更の検討 end↑
          });
        }

        // UPD 2024/12/16 ZLL 課題_受注製品変更の検討 start↓
        // // 画面状態：true:新規　false:編集
        // if (this.isAddFlg) {
        //   // 運送状態:未運送
        //   this.receInfoEditForm.crbTransStatus =
        //     FINAL_STR.TRANS_STATUS_NO_TRANS;
        // }

        // // リクエスト データ
        // const requestData = {
        //   BasicInfo: this.receInfoEditForm,
        //   DetailInfo: DetailInfo,
        // };

        // // 画面状態：true:新規　false:編集
        // if (this.isAddFlg) {
        //   // フォーカス削除
        //   this.$refs.confirmBtn.$el.blur();

        //   creatReceInfo(requestData)
        //     .then((res) => {
        //       Message.showSuccess(t("message.COMMON_MESSAGE.ADD_SUCCESS"));
        //       //入荷No
        //       this.receInfoEditForm.crbReceNo = res.ReceNo;

        //       // 画面状態：true:新規　false:編集
        //       this.isAddFlg = false;

        //       // 運送状態表示Flag
        //       this.trStatusShowFlg = true;

        //       // 仕入先Flg
        //       this.supFlg = true;

        //       // 運送状態追加
        //       this.generateColumns();

        //       // 入荷詳細画面情報の取得
        //       this.getReceDetialInfoByReceNo(this.receInfoEditForm.crbReceNo);
        //     })
        //     .catch((err) => {
        //       if (err.data != null) {
        //         Message.showError(
        //           t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
        //         );
        //       } else {
        //         Message.showError(t("message.COMMON_MESSAGE.ADD_FAILURE"));
        //       }
        //     })
        //     .finally(() => {
        //       this.loading = false;
        //     });
        // } else {
        //   changReceInfo(requestData)
        //     .then((res) => {
        //       Message.showSuccess(t("message.COMMON_MESSAGE.UPDATE_SUCCESS"));

        //       this.numLoads = 1;

        //       // 入荷詳細画面情報の取得
        //       this.getReceDetialInfoByReceNo(this.receInfoEditForm.crbReceNo);
        //     })
        //     .catch((err) => {
        //       if (err.data != null) {
        //         Message.showError(
        //           t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
        //         );
        //       } else {
        //         Message.showError(t("message.COMMON_MESSAGE.UPDATE_FAILURE"));
        //       }
        //     })
        //     .finally(() => {
        //       this.loading = false;
        //     });
        // }

        let hasNegativeRemnant = this.creDetailInfoTable.some(function (item) {
          return item.crdRecelRemnant < 0;
        });
        if (hasNegativeRemnant) {
          let message = t("message.CHECK_RECE_INFO.RCV_QTY_REMAIN_CONFIRM");

          Modal.showWarning("", message, {
            $type: "prompt",
            confirmButtonText: t("resource.COMMON_CONSTANT.YES"),
            cancelButtonText: t("resource.COMMON_CONSTANT.NO"),
            showCancelButton: true,
          })
            .then(() => {
              this.saveDataProc(DetailInfo);
            })
            .finally(() => {
              if (this.loading) {
                this.loading = false;
              }
            });
        } else {
          this.saveDataProc(DetailInfo);
        }
        // ADD 2025/12/08 ZLL 課題_251208顧客からの改善したい点への対応 start↓
      } else {
        Modal.showWarning("", t("message.COMMON_MESSAGE.PLEASE_SELECT_DATA"))
          .then(() => {})
          .catch(() => {})
          .finally(() => {
            // フォーカス削除
            this.$refs.confirmBtn.$el.blur();

            this.loading = false;
          });
      }
      // ADD 2025/12/08 ZLL 課題_251208顧客からの改善したい点への対応 end↑
      // UPD 2024/12/16 ZLL 課題_受注製品変更の検討 end↑
    },

    // ADD 2024/12/16 ZLL 課題_受注製品変更の検討 start↓
    saveDataProc(DetailInfo) {
      // 画面状態：true:新規　false:編集
      // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
      // 運送状態の削除
      // if (this.isAddFlg) {
      //   // 運送状態:未運送
      //   this.receInfoEditForm.crbTransStatus = FINAL_STR.TRANS_STATUS_NO_TRANS;
      // }
      // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑

      // リクエスト データ
      const requestData = {
        BasicInfo: this.receInfoEditForm,
        DetailInfo: DetailInfo,
      };

      // 画面状態：true:新規　false:編集
      if (this.isAddFlg) {
        // フォーカス削除
        this.$refs.confirmBtn.$el.blur();

        creatReceInfo(requestData)
          .then((res) => {
            Message.showSuccess(t("message.COMMON_MESSAGE.ADD_SUCCESS"));
            //入荷No
            this.receInfoEditForm.crbReceNo = res.ReceNo;

            // 画面状態：true:新規　false:編集
            this.isAddFlg = false;

            // 運送状態表示Flag
            this.trStatusShowFlg = true;

            // 仕入先Flg
            this.supFlg = true;

            // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
            // 運送状態の削除
            // 運送状態追加
            // this.generateColumns();
            // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑

            // 入荷詳細画面情報の取得
            this.getReceDetialInfoByReceNo(this.receInfoEditForm.crbReceNo);
          })
          .catch((err) => {
            if (err.data != null) {
              Message.showError(
                t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
              );
            } else {
              Message.showError(t("message.COMMON_MESSAGE.ADD_FAILURE"));
            }
          });
        // DEL 2026/10/10 Wjx フロント画面コントロールのロードの最適化 start↓
        // 詳細情報の取得が完了するまで待ってからloadingをオフにする。ここではまだ「取得完了」していないのにクローズしている
        // .finally(() => {
        //   this.loading = false;
        // });
        // DEL 2026/10/10 Wjx フロント画面コントロールのロードの最適化 end↑
      } else {
        changReceInfo(requestData)
          .then((res) => {
            Message.showSuccess(t("message.COMMON_MESSAGE.UPDATE_SUCCESS"));

            this.numLoads = 1;

            // 入荷詳細画面情報の取得
            this.getReceDetialInfoByReceNo(this.receInfoEditForm.crbReceNo);
          })
          .catch((err) => {
            if (err.data != null) {
              Message.showError(
                t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
              );
            } else {
              Message.showError(t("message.COMMON_MESSAGE.UPDATE_FAILURE"));
            }
          });
        // DEL 2026/10/10 Wjx フロント画面コントロールのロードの最適化 start↓
        // 詳細情報の取得が完了するまで待ってからloadingをオフにする。ここではまだ「取得完了」していないのにクローズしている
        //.finally(() => {
        //    this.loading = false;
        //  });
        // DEL 2026/10/10 Wjx フロント画面コントロールのロードの最適化 end↑
      }
    },
    // ADD 2024/12/16 ZLL 課題_受注製品変更の検討 end↑

    inputCheck(element) {
      // UPD 2024/12/16 ZLL 課題_受注製品変更の検討 start↓
      // 入荷済み数 >= 0
      // if (element.crdRecelRemnant < 0) {
      //   let message =
      //     "製品「" +
      //     element.aodProdName +
      //     "」の" +
      //     t("message.CHECK_RECE_INFO.CLOSE_NG_CHECK");

      //   Modal.showWarning("", message, {
      //     confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
      //   });
      //   return false;
      // }

      // 入荷数 > 0
      if (element.crdReceQty <= 0) {
        let message =
          "製品「" +
          element.aodProdName +
          "」の" +
          t("message.CHECK_RECE_INFO.CLOSE_NG_CHECK");

        Modal.showWarning("", message, {
          confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
        });
        return false;
      }
      // UPD 2024/12/16 ZLL 課題_受注製品変更の検討 end↑

      // 寸法検査NG数 > 入荷数
      if (element.crdSizeCheckNgQty > element.crdReceQty) {
        let message =
          "製品「" +
          element.aodProdName +
          "」の" +
          t("message.CHECK_RECE_INFO.RECE_NG_CHECK");
        Modal.showWarning("", message, {
          confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
        });

        return false;
      }

      return true;
    },

    focusNextInput(index, columnProp) {
      index = index + 1;

      if (index > this.creDetailInfoTable.length - 1) {
        this.$refs[`input${0}${columnProp}`][0].focus();
      } else {
        this.$refs[`input${index}${columnProp}`][0].focus();
      }
    },

    outCheckListBtnClick() {
      outCheckList()
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "文件名.xlsx"); // 任意的文件名
          document.body.appendChild(link);
          link.click();
          link.parentNode.removeChild(link);
        })
        .catch((err) => {});

      // フォーカス削除
      this.$refs.outCheckListBtn.$el.blur();
    },

    // 仕入先
    changeSelectData(value) {
      let result = this.supplierList.find((obj) => obj.supCode === value);
      this.receInfoEditForm.crbSupInfo = result
        ? result.supCode + ":" + result.supAbbreviation
        : null;

      // ADD 2025/12/08 ZLL 課題_251208顧客からの改善したい点への対応 start↓
      if (value !== this.oldSupCode) {
        this.creDetailInfoTable = [];
      }
      // ADD 2025/12/08 ZLL 課題_251208顧客からの改善したい点への対応 end↑
    },

    // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
    // // 運送状態追加
    // generateColumns() {
    //   // 運送状態
    //   let crdTransStatusNameObj = {
    //     prop: "crdTransStatusName",
    //     label: t("resource.checkReceInfo.crbTransStatus"),
    //     width: t("widgetSize.tableCommon.defaultWidth"),
    //     class: "cell_txt_center",
    //     overflowTooltip: false,
    //   };

    //   // 画面状態：true:新規　false:編集
    //   if (!this.isAddFlg) {
    //     let insertIndex = this.columns.findIndex(
    //       (obj) => obj.prop === "crdSizeCheckNgQty"
    //     );

    //     if (insertIndex !== -1) {
    //       this.columns.splice(insertIndex + 1, 0, crdTransStatusNameObj);
    //     }
    //   }
    // },
    // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑

    /**
     * el-table-column 自适应列宽
     * @param prop_label: 表名
     * @param table_data: 表格数据
     */
    flexColumnWidthFunc(label, prop) {
      return flexColumnWidth(label, prop, this.creDetailInfoTable);
    },

    importExcel() {
      // フォーカス削除
      this.$refs.importExcel.$el.blur();

      const input = document.createElement("input");
      input.type = "file";
      input.accept = ".xlsx";

      input.addEventListener("change", (e) => {
        const file = e.target.files[0];

        if (!file || !file.name.endsWith(".xlsx")) {
          this.showWaringMessage("xlsx 形式のファイルを選択してください");
          return;
        }

        let maxSize = 5 * 1024 * 1024;

        if (file.size > maxSize) {
          this.showWaringMessage(
            "ファイルサイズが大きすぎます。5MB未満のファイルを選択してください"
          );
          return;
        }

        // UPD 2025/08/21 WZC 課題_日本入荷の配送単導入機能の追加 start↓
        // this.readZColumnFromXLSX(file).then((result) => {
        readZColumnFromXLSX(file).then((result) => {
          // UPD 2025/08/21 WZC 課題_日本入荷の配送単導入機能の追加 end↑
          try {
            const { jsonDataWithHeader, zColumnValues } = result;

            this.loading = true;

            this.fileJsonData = [];

            if (
              jsonDataWithHeader.length <= 0 ||
              typeof jsonDataWithHeader[0][0] === "undefined" ||
              jsonDataWithHeader[1][0].indexOf("NO.") == -1 ||
              // UPD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 start↓
              // 課題_納期分割機能の追加
              // jsonDataWithHeader[1][25] != "詳細NO" ||
              // UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓
              // 配送単の「得意先納期」列の追加
              // jsonDataWithHeader[1][26] != "詳細NO" ||
              jsonDataWithHeader[1][27] != "詳細NO" ||
              // UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑
              // UPD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 end↑
              zColumnValues.length <= 0
            ) {
              this.showWaringMessage(
                "選択したファイルのフォーマットが間違った、確認してください"
              );
              return;
            }

            for (let i = 2; i < jsonDataWithHeader.length; i++) {
              if (
                !(
                  !isNaN(jsonDataWithHeader[i][0]) &&
                  jsonDataWithHeader[i][1] != ""
                )
              ) {
                break;
              }

              let hiddenData = JSON.parse(jsonDataWithHeader[i][25]);
              // ADD 2025/08/21 WZC 課題_日本入荷の配送単導入機能の追加 start↓
              let misumiKbn = hiddenData.MisumiKbn;
              let supFacKbn = hiddenData.SupFacKbn;

              // 日本工場、ミスミ大連以外の場合、取り込み不可
              if (supFacKbn != STR_ONE && misumiKbn != STR_FIVE) {
                this.showWaringMessage(
                  "選択したファイルの仕入先が間違った、確認してください"
                );
                return;
              }
              // ADD 2025/08/21 WZC 課題_日本入荷の配送単導入機能の追加 end↑

              let lineData = {
                indexNo: jsonDataWithHeader[i][0],
                crdOrderNoShow: jsonDataWithHeader[i][1],
                // UPD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 start↓
                // 課題_納期分割機能の追加
                // aodProdName: jsonDataWithHeader[i][2],
                // aodProdDrawNo: jsonDataWithHeader[i][3],
                // prodExKbn: jsonDataWithHeader[i][4],
                // crdReceQty: jsonDataWithHeader[i][5],
                // crdSizeCheckNgQty: jsonDataWithHeader[i][6],
                // // UPD 2025/2/27 Wjx (#34631)取込フォーマットに見積No.のチェックの変更 start↓
                // //crdSizeCheckOkQty: jsonDataWithHeader[i][7],
                // crdSizeCheckOkQty:
                //   jsonDataWithHeader[i][5] - jsonDataWithHeader[i][6],
                // // UPD 2025/2/27 Wjx (#34631)取込フォーマットに見積No.のチェックの変更 end↑
                // // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
                // // 課題_備考機能の追加
                // // crdRemarks: jsonDataWithHeader[i][8],
                // aodProdRemarksSum: jsonDataWithHeader[i][8],
                // // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
                odDueDate: jsonDataWithHeader[i][2], // 仕入先納期列
                // UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓
                // aodProdName: jsonDataWithHeader[i][3],
                // aodProdDrawNo: jsonDataWithHeader[i][4],
                // prodExKbn: jsonDataWithHeader[i][5],
                // crdReceQty: jsonDataWithHeader[i][6],
                // crdSizeCheckNgQty: jsonDataWithHeader[i][7],
                // crdSizeCheckOkQty:
                //   jsonDataWithHeader[i][6] - jsonDataWithHeader[i][7],
                // aodProdRemarksSum: jsonDataWithHeader[i][9],

                aodProdName: jsonDataWithHeader[i][4],
                aodProdDrawNo: jsonDataWithHeader[i][5],
                prodExKbn: jsonDataWithHeader[i][6],
                crdReceQty: jsonDataWithHeader[i][7],
                crdSizeCheckNgQty: jsonDataWithHeader[i][8],
                crdSizeCheckOkQty:
                  jsonDataWithHeader[i][7] - jsonDataWithHeader[i][8],
                aodProdRemarksSum: jsonDataWithHeader[i][10],
                // UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑
                // UPD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 end↑

                odOrderNo: hiddenData.OrderNo,
                odOrderDetailNo: hiddenData.OdOrderDetailNo,
              };

              this.fileJsonData.push(lineData);
            }

            if (this.fileJsonData.length == 0) {
              this.showWaringMessage(
                "選択したファイルのフォーマットが間違った、確認してください"
              );
              return;
            }

            searchCheckReceByDeliceryFile(this.fileJsonData)
              .then((res) => {
                if (res.Result) {
                  this.creDetailInfoTable = res.ReceDetailInfos;

                  this.receInfoEditForm.crbSupCode = res.SupCode;
                  // 仕入先の履歴
                  this.oldSupCode = this.receInfoEditForm.crbSupCode;

                  // ADD 2025/08/07 WZC 課題_250725顧客からの改善したい点への対応 start↓
                  // 仕入先Code: 仕入先名
                  let result = this.supplierList.find(
                    (obj) => obj.supCode === res.SupCode
                  );
                  this.receInfoEditForm.crbSupInfo = result
                    ? result.supCode + ":" + result.supAbbreviation
                    : null;
                  // ADD 2025/08/07 WZC 課題_250725顧客からの改善したい点への対応 end↑

                  setColumnWidth(this.columns, this.creDetailInfoTable);

                  // データの読み込
                  this.dataProcess();

                  // 確定ボタンFlag
                  this.btnClickFlg = false;

                  this.showReceNoFlg = true;
                } else {
                  ShowImportResultDialog(
                    {
                      CheckReceByDeliceryDtos: res.CheckReceByDeliceryDtos,
                    },
                    "配送単導入詳細情報",
                    (target) => {
                      if (!!target) {
                      }
                    }
                  );
                }
              })
              .catch((err) => {
                if (err.data != null) {
                  // UPD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 start↓
                  // Message.showError(
                  //   t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
                  // );
                  Message.showError(err.data.Messages[0].Message);
                  // UPD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 end↑
                } else {
                  this.showWaringMessage(
                    "選択したファイルのフォーマットが間違った、確認してください"
                  );
                }
              })
              .finally(() => {
                this.loading = false;
              });
          } catch (error) {
            this.showWaringMessage(
              "選択したファイルのフォーマットが間違った、確認してください"
            );
          }
        });
      });

      input.click();
    },

    showWaringMessage(message) {
      Modal.showWarning("", message, {
        confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
        onClose: () => {
          this.loading = false;
        },
      }).then(() => {
        this.loading = false;
      });
    },

    extractDetails(data) {
      return data.map((item) => {
        return {
          crdProdExKbn: item.crdProdExKbn,
          crdOrderNo: item.crdOrderNo,
          crdDetailNo: item.crdDetailNo,
          crdReceQty: item.crdReceQty,
          crdSizeCheckNgQty: item.crdSizeCheckNgQty,
          // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
          // 課題_備考機能の追加
          // crdRemarks: item.crdRemarks || "",
          // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
        };
      });
    },

    extractBasic(data) {
      return {
        crbReceNo: data.crbReceNo,
        crbSupCode: data.crbSupCode,
        crbUserCode: data.crbUserCode,
        crbReceDate: data.crbReceDate,
        // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
        // 運送状態の削除
        // crbStatus: data.crbStatus,
        // crbTransStatus: data.crbTransStatus,
        // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
      };
    },

    // DEL 2025/08/21 WZC 課題_日本入荷の配送単導入機能の追加 start↓
    // 共通関数の使用
    /*readZColumnFromXLSX(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (event) => {
          const data = new Uint8Array(event.target.result);
          const workbook = XLSX.read(data, { type: "array" });
          const sheetName = workbook.SheetNames[0];
          const sheet = workbook.Sheets[sheetName];

          const jsonDataWithHeader = XLSX.utils.sheet_to_json(sheet, {
            header: 1,
          });

          const zColumnValues = [];
          for (const rowKey in sheet) {
            if (rowKey.length > 1 && rowKey[0] === "Z" && rowKey[1] !== "Z") {
              const cellValue = sheet[rowKey].v
                ? sheet[rowKey].v
                : sheet[rowKey];
              zColumnValues.push(cellValue);
            }
          }

          const result = {
            jsonDataWithHeader: jsonDataWithHeader,
            zColumnValues: zColumnValues,
          };
          resolve(result);
        };
        reader.readAsArrayBuffer(file);
      });
    },*/
    // DEL 2025/08/21 WZC 課題_日本入荷の配送単導入機能の追加 end↑

    // ダイアログを閉じる
    onCancel() {
      let isDataChanged = false;
      if (this.isAddFlg) {
        isDataChanged = this.creDetailInfoTable.length > 0;
      } else {
        const extractedBasic = this.extractBasic(this.receInfoEditForm);
        const extractedDetails = this.extractDetails(this.creDetailInfoTable);
        isDataChanged =
          !cmpBasicData(this.cmpBasicResult, extractedBasic) ||
          !cmpDetailData(this.cmpDetailResult, extractedDetails);
      }

      if (isDataChanged) {
        return new Promise((resolve, reject) => {
          Modal.showWarning(
            "",
            t("message.COMMON_MESSAGE.DATA_ALREADY_CHANGED_CLOSE"),
            {
              $type: "prompt",
              confirmButtonText: t("resource.button.sure"),
              cancelButtonText: t("resource.button.cancel"),
              showCancelButton: true,
            }
          )
            .then(() => {
              // 用户点击确认
              resolve(true);
            })
            .catch((error) => {
              // 用户点击取消或关闭对话框
              resolve(false);
            });
        });
      } else {
        return true;
      }
    },
    // ADD 2024/12/16 ZLL 課題_受注製品変更の検討 start↓
    // 入力ボックスをクリックの場合、値をすべて選択します
    selectValue(e) {
      e.target.select();
    },
    // ADD 2024/12/16 ZLL 課題_受注製品変更の検討 end↑

    // ADD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
    // 課題_備考機能の追加
    addRemarksProd(row, event) {
      // フォーカス削除
      event.currentTarget.blur();
      if (!this.loading) {
        this.loading = true;
      }
      let remarks = STR_EMPTY;
      showRemarksUpdDialog(
        this,
        row.crdQuoteNo,
        row.crdProdNo,
        row.aodProdRemarksSum
      )
        .then((value) => {
          remarks = value;
        })
        .finally(() => {
          this.numLoads = 1;

          // 入荷詳細画面情報の取得
          //this.getReceDetialInfoByReceNo(this.receInfoEditForm.crbReceNo);

          // 待ちダイアログを閉じる
          if (this.loading) {
            this.loading = false;
          }
          if (remarks != STR_EMPTY) {
            // 備考を更新する
            row.aodProdRemarksSum = remarks;
          }
        });
    },

    //備考表示用
    formatRemarksShowProc(value) {
      return formatRemarksShow(value);
    },

    getIconTypeProc(value) {
      return getIconType(value);
    },

    // ADD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
    // ADD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 start↓
    // 共通備考の調整（備考列幅の設定）
    getRemarksColumnWidthProc() {
      return getRemarksColumnWidth(this.creDetailInfoTable);
    },

    //共通備考の調整（備考の表示と保存）
    showRemarksDialogProc(row, event) {
      // フォーカス削除
      event.currentTarget.blur();
      if (!this.loading) {
        this.loading = true;
      }

      showRemarksDialog(
        this,
        row.crdQuoteNo,
        row.crdProdNo,
        row.aodProdRemarksSum,
        row.aodProdRemarksSum,
        // UPD 2025/08/07 ZLL 課題_250725顧客からの改善したい点への対応 start↓
        // this.aodUpdateTime
        row.aodUpdateTime
        // UPD 2025/08/07 ZLL 課題_250725顧客からの改善したい点への対応 end↑
      )
        .then((res) => {
          if (!this.isEmptyOrNull(res)) {
            // 備考を更新する
            row.aodProdRemarksSum = res.aodProdRemarks;
            // UPD 2025/08/07 ZLL 課題_250725顧客からの改善したい点への対応 start↓
            // 内部バグ_「複数の見積番号、備考入力保存時に排他メッセージが表示される」問題の修正
            // this.aodUpdateTime = res.aodUpdateTime;
            row.aodUpdateTime = res.aodUpdateTime;

            this.creDetailInfoTable
              .filter((item) => item.crdQuoteNo === row.crdQuoteNo)
              .forEach((item) => {
                item.aodUpdateTime = row.aodUpdateTime;
              });
            // UPD 2025/08/07 ZLL 課題_250725顧客からの改善したい点への対応 end↑
            this.$set(this.creDetailInfoTable, row.index, row);
          }
        })
        .finally(() => {
          this.numLoads = 1;

          // 待ちダイアログを閉じる
          if (this.loading) {
            this.loading = false;
          }
        });
    },
    //値がNULLまたはEmptyです
    isEmptyOrNull(item) {
      if (item == undefined || item == STR_EMPTY) {
        return true;
      } else {
        return false;
      }
    },
    // ADD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 end↑
  },
};
</script>
<style scoped>
.el-table__body {
  height: 200px;
}
</style>
